import { Component } from "@angular/core";

@Component({
    selector: "app-cp-02-99-06-07",
    standalone: true,
    templateUrl: "./cp-02-99-06-07.component.html",
    styleUrls: ["./cp-02-99-06-07.component.scss"],
})
export class CP02990607Componet{
    
}